import { useQuery } from 'hooks/useCustomQuery';
import { useSelector } from 'react-redux';
import getEngineLocations from 'API/EngineLocation/getEngineLocations';

const useGetEngineLocations = () => {
    const { currentScope } = useSelector((state) => ({ ...state.login }));
    return useQuery({
        queryKey: ['engineLocations', currentScope],
        queryFn: () => getEngineLocations(currentScope),
        refetchOnWindowFocus: false,
        enabled: !!currentScope,
        staleTime: 0,
    });
};

export default useGetEngineLocations;
